module.exports = __webpack_public_path__ + "img/boot.1762c4af.png";